import get from 'lodash/get';

import { ORGANIZATIONS__FETCH_ONE } from '../constants';

export const hydrateOrganizationFromShell = (store) => {
  const organization = get(window, 'beagly.organization');
  if (!organization || !organization.id) return;
  store.dispatch({ type: ORGANIZATIONS__FETCH_ONE, data: [organization] });
};
